var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4933 7.10156C14.4933 7.10156 14.0861 12.1528 13.8498 14.2806C13.7373 15.2968 13.1096 15.8923 12.0813 15.9111C10.1246 15.9463 8.1656 15.9486 6.2096 15.9073C5.22035 15.8871 4.6031 15.2841 4.49285 14.2858C4.2551 12.1393 3.8501 7.10156 3.8501 7.10156",
    stroke: "#EC4E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.531 4.67969H2.8125",
    stroke: "#EC4E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0804 4.67925C12.4917 4.67925 11.9847 4.263 11.8692 3.68625L11.6869 2.77425C11.5744 2.3535 11.1934 2.0625 10.7592 2.0625H7.58443C7.15018 2.0625 6.76918 2.3535 6.65668 2.77425L6.47443 3.68625C6.35893 4.263 5.85193 4.67925 5.26318 4.67925",
    stroke: "#EC4E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/Delete.75699288c68ee83ee2a630ed0b23a15e.svg";
export { ForwardRef as ReactComponent };